module.exports = __webpack_public_path__ + "7b14cb0171852b043dadbeb9aa869dc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/img-gear@3x.png
// module id = 1842
// module chunks = 1